import React from 'react';
import Pagina1 from './Paginas/Pagina1.js';
import Pagina2 from './Paginas/Pagina2.js';
import Pagina3 from './Paginas/Pagina3.js';
import Pagina7 from './Paginas/Pagina7.js';

function SDTemplate({ data }) {

  return (
    <>
      <div>
        <Pagina1 {...{ data }}/>
        <Pagina2 {...{ data }}/>
        <Pagina3 {...{ data }}/>
        <Pagina7 {...{ data }}/>
      </div>
    </>
  );
};

export default SDTemplate;